import catagories1 from '../assets/images/catagories/portfolio.jpg'
import catagories2 from '../assets/images/catagories/conversation.jpg'
import catagories3 from '../assets/images/catagories/business.jpg'
import catagories4 from '../assets/images/catagories/community.jpg'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'


import partner1 from '../assets/images/Brochure_Deymed_Duomag/0.png'
import partner2 from '../assets/images/Brochure_Deymed_Duomag/2.png'
import partner3 from '../assets/images/Brochure_Deymed_Duomag/14.png'
import partner4 from '../assets/images/Brochure_Deymed_Duomag/logo_3.png'
import partner5 from '../assets/images/client/google.svg'
import partner6 from '../assets/images/client/amazon.svg'

import team1 from '../assets/images/team/01.jpg'
import team2 from '../assets/images/team/02.jpg'
import team3 from '../assets/images/team/03.jpg'
import team4 from '../assets/images/team/04.jpg'
import team5 from '../assets/images/team/05.jpg'
import team6 from '../assets/images/team/06.jpg'
import team7 from '../assets/images/team/07.jpg'
import team8 from '../assets/images/team/08.jpg'

import team9 from '../assets/images/team/doctor_tong.png'
import team12 from '../assets/images/team/doctor_tong.png'
import team14 from '../assets/images/team/doctor_tong.png'
import team15 from '../assets/images/team/doctor_tong.png'


import cases1 from '../assets/images/Brochure_RehaCom/42.png'
import cases2 from '../assets/images/Brochure_RehaCom/4.jpg'
import cases3 from '../assets/images/Brochure_RehaCom/5.png'
import cases4 from '../assets/images/Brochure_RehaCom/41.png'
import cases5 from '../assets/images/Brochure_RehaCom/55.png'
import cases6 from '../assets/images/Brochure_RehaCom/59.jpg'
import cases7 from '../assets/images/Brochure_RehaCom/60.jpg'
import cases8 from '../assets/images/Brochure_RehaCom/61.jpg'
import cases9 from '../assets/images/Brochure_RehaCom/66.jpg'





import { LuBrainCircuit, LuSmile, LuPill, LuGitPullRequestClosed, LuBrainCog, FaLinkedin, FaFacebookF, FaInstagram, FaTwitter, FiMail, AiOutlineQuestionCircle, LiaFileInvoiceSolid, FiSettings,  LuBookOpenCheck,  LuActivitySquare, LuCheckCircle2} from '../assets/icons/vander'
import { FaWhatsapp } from 'react-icons/fa6'

export const catagories = [
    {
        image:catagories1,
        title:'Portfolio'
    },
    {
        image:catagories2,
        title:'Conversation'
    },
    {
        image:catagories3,
        title:'Business'
    },
    {
        image:catagories4,
        title:'Community'
    },
]

export const accordionData = [
    {
        id:1,
        title:'Based On Bootstrap 5',
        desc:'There are many variations of Faff about only a quid blower I don’t want no agro bleeding chimney pot burke tosser cras nice one boot fanny.! passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'Built With SASS',
        desc:'There are many variations of Faff about only a quid blower I don’t want no agro bleeding chimney pot burke tosser cras nice one boot fanny.! passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'Easy to customize',
        desc:'There are many variations of Faff about only a quid blower I don’t want no agro bleeding chimney pot burke tosser cras nice one boot fanny.! passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
]
export const feature = [
    {
        icon:LuActivitySquare,
        title:'Dolor crónico',
        desc:"Es una de las aplicaciones más comunes, incluyendo dolor neuropático, fibromialgia, lumbalgia, ciática, dolor fantasma, etc."
    },
    {
        icon:LuBrainCog,
        title:'Trastornos neurológicos',
        desc:"Enfermedad de Parkinson, temblor esencial, distonía, epilepsia resistente al tratamiento."
    },
    {
        icon:LuBrainCircuit,
        title:'Trastornos psiquiátricos',
        desc:"Depresión resistente, ansiedad, TDAH, Trastorno bipolar, Trastorno del sueño, TOC, Trastorno de pánico, Estrés post-traumático, Abuso de sustancias, Esquizofrenía. "
    },
    {
        icon:LuGitPullRequestClosed,
        title:'Disfunciones neuromusculoesqueléticas',
        desc:"Lesiones ligamentosas, capsulo-articulares, tono muscular alterado, atrapamientos nerviosos."
    },
    {
        icon:LuCheckCircle2,
        title:'Mejora de la función',
        desc:"Restablecimiento de la función del sistema nervioso (periférico, central, somático, autonómico, sensorial, motor, vascular, glandular, visceral), mejora del control motor y la propiocepción."
    },
    {
        icon:LuPill,
        title:'Reducción de la necesidad de analgésicos',
        desc:"Ofrece una alternativa o complemento a la medicación."
    },
    {
        icon:LuBookOpenCheck,
        title:'Mínimamente invasiva (en muchos casos) y personalizable',
        desc:"Permite ajustar los parámetros de la terapia a las necesidades de cada paciente."
    },
    {
        icon:LuSmile,
        title:'Mejora de la calidad de vida',
        desc:"Alivia el dolor, mejora la movilidad y el bienestar general."
    },
]

export const clientOneData = [
    {
        image:client1,
        name:'Nombre apellido',
        title:'Paciente',
        desc:'"Muchas gracias por su diagnóstico. El trato fue amable y respetuoso."'
    },
    {
        image:client2,
        name:'Nombre apellido',
        title:'Paciente',
        desc:'"El doctor fue muy claro en el tratamiento y el seguimiento al padecimiento."'
    },
    {
        image:client3,
        name:'Nombre apellido',
        title:'Paciente',
        desc:'"Después de mucho tiempo en investigar un lugar que me diagnosticaran por fín tuve el apoyo que necesitaba."'
    },
    {
        image:client4,
        name:'Nombre apellido',
        title:'Paciente',
        desc:'"¡Gracias por todo doctores!"'
    },
    {
        image:client5,
        name:'Nombre apellido',
        title:'Paciente',
        desc:'"Llevo 5 meses atendiendome con el Dr. y hasta la fecha me he sentido muy bien!, Lo recomiendo!"'
    },
]
export const partnerImage = [
    partner1,partner2,partner3, partner4
]

export const landing = [
   'Agency','Software','Startup','Business','Hosting','Studio','Application','Freelancer' 
]
export const about = [
    'About us','Services','Team','Terms Policy','Privacy Policy','Login','FAQ','Blog' 
 ]
 export const location = [
    'San Francisco','Tokio','South Korea','Myanmar' 
 ]

 export const footerSocial = [    
   
    {
        icon: FaFacebookF,
        link:'https://www.facebook.com/share/1GcRMpSSb9/?mibextid=wwXIfr'
    },
    {
        icon: FaInstagram,
        link:'https://www.instagram.com/neuromodulacionsonora?igsh=OW9iNXRzMzByeGww&utm_source=qr'
    },

    {
        icon: FaWhatsapp,
        link:'https://wa.me/+5216623604491?text=Información CNRC' 
    },
    {
        icon: FiMail,
        link:'mailto:contacto@neuromodulacionsonora.com'
    },    
 ]

 export const TeamData = [
    {
        image:team15,
        name:'Juan Manuel Tong',
         position:'Dr. Psiquiatra',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    /*{
        image:team9,
        name:'Juan Antonio Tong',
        position:'Dr. Psiquiatra',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team12,
        name:'Nombre apellido',
        position:'Dr. Neurólogo',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team14,
        name:'Nombre apellido',
        position:'Camillero',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },*/
 ]

 export const teamOne = [
    {
        image:team1,
        name:'Calvin Carlo',
        position:'Founder',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team2,
        name:'Martin Sobhe',
        position:'C.E.O.',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team3,
        name:'Bobby DE',
        position:'Developer',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team4,
        name:'Cristino Murphy',
        position:'Designer',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team5,
        name:'Amanda Hyer',
        position:'Developer',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team6,
        name:'Jean Vega',
        position:'Graphic Designer',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team7,
        name:'Laura Chandler',
        position:'Developer',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team8,
        name:'Joyce Lapoint',
        position:'Designer',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
 ]

 export const helpFeature = [
    {
        icon:AiOutlineQuestionCircle,
        iconColor:'text-info h1',
        title:'FAQs',
        desc:'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.',
        link:'/help-faq'
    },
    {
        icon:LiaFileInvoiceSolid,
        iconColor:'text-danger h1',
        title:'Guides / Support',
        desc:'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.',
        link:'/help-guides'
    },
    {
        icon:FiSettings,
        iconColor:'text-warning h1',
        title:'Support Request',
        desc:'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.',
        link:'/help-support'
    },
 ]

 export const faqData = [
    {
        id:1,
        title:'How does it work ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'Do I need a designer to use leaping ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'What do I need to do to start selling ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'What happens when I receive an order ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
 ]

 export const guides = [
    {
        title:'Your account',
        feature:[
            'Your profile',
            'Account security',
            'Identification & verifications',
            'Reviews',
            'Superhost status'
        ]
    },
    {
        title:'Getting started',
        feature:[
            'Deciding to purchase',
            'List your space',
            'Landing an experience or adventure',
            'Top uses questions',
        ]
    },
    {
        title:'Your calendar',
        feature:[
            'Pricing & availability',
            'Booking settings',
            'Responding to enquiries & requests',
            'Snoozing or deactivating your listing',
        ]
    },
    {
        title:'Your listings',
        feature:[
            'Updating your listing',
            'Neighbourhoods',
            'Listing photos & photography',
            'leaping Plus',
            'API-connected software'
        ]
    },
    {
        title:'How payouts work',
        feature:[
            'Getting paid',
            'Adding payout info',
            'Your payout status',
            'Donations',
            'Taxes'
        ]
    },
    {
        title:'Your reservations',
        feature:[
            'leaping safely',
            'leaping Experiences and Adventures',
            'Changing a reservation',
            'Cancelling a reservation',
            'Long-term reservations'
        ]
    },
    {
        title:'Reservation help',
        feature:[
            'Help with a reservation or guest',
            'Guest cancellations',
        ]
    },
 ]

 export const casesData = [
    {
        image:cases1,
        name:'Evaluación cognitiva',
        title:'Diagnóstico'
    },
    {
        image:cases2,
        name:'Teclado especializado',
        title:'Hardware de RehaCom'
    },
    {
        image:cases3,
        name:'Entrenamiento cognitivo',
        title:'Hardware de RehaCom'
    },
    {
        image:cases4,
        name:'Trabajo personalizado',
        title:'Diseño del Software'
    },
    {
        image:cases5,
        name:'Comportamiento de reacción',
        title:'Atención'
    },
    {
        image:cases6,
        name:'Atención y concentración',
        title:'Atención'
    },
    {
        image:cases7,
        name:'Atención dividida',
        title:'Atención'
    },
    {
        image:cases8,
        name:'Atención dividida',
        title:'Atención'
    },
    {
        image:cases9,
        name:'Memoria de trabajo',
        title:'Memoria'
    },
 ]